import { FC } from 'react';
import styled from 'styled-components';
import useSWR from 'swr';
import UserType from 'types/User';
import NavigationLayout from './NavigationLayout';
import SectionLinks from './SectionLinks';
// Icons
import User from './User';

export const List = styled.ul`
  overflow-y: auto;

  list-style: none;

  a {
    text-decoration: none;
    white-space: nowrap;
  }
`;

const Usage: FC = (props) => {
  const { data: user }: { data?: UserType } = useSWR('/auth/profile');
  return user ? (
    <NavigationLayout {...props}>
      <List>
        <SectionLinks />
      </List>
      <User />
    </NavigationLayout>
  ) : null;
};

export default Usage;
